// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__eN-iT","imageUploader":"EGiftCard_imageUploader__1YrOV"};